import { gleamerT } from '@gleamer/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import { AlertDialog } from '../atoms/AlertDialog';

/**
 * The review viewer was given a case to label: a reviewer of a task only gets review cases, but next-item first
 * returns a case the person still holds. The case must be finished in the label viewer before reviewing.
 */
export function HeldCaseAlert({ taskName }: { taskName?: string }) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const taskId = searchParams.get('held');
  const itemId = searchParams.get('item');

  const onClose = () => {
    searchParams.delete('held');
    searchParams.delete('item');
    setSearchParams(searchParams);
  };

  const labelUrl = new URLSearchParams({ task: taskId });
  if (itemId) {
    labelUrl.set('item', itemId);
  }

  return (
    <AlertDialog onClose={onClose}>
      <p className="text-base text-gray-900">
        {gleamerT(t, 'review.heldCase', {
          task: taskName ? `${taskName} (${taskId})` : taskId,
        })}
      </p>
      <p className="mt-2 text-base">
        <Link
          className="text-blue-700 underline"
          to={`/ohif/label?${labelUrl}`}
        >
          {gleamerT(t, 'review.openHeldCase')}
        </Link>
      </p>
    </AlertDialog>
  );
}
